import { Trainer } from "./trainer"

export const Snowboard = ({ trainers, selectedDate }) => {
  return (
    <div className='row'>
      {trainers?.map(el => (
        <Trainer trainer={el} key={el.trainer_ID} type={'Сноуборд'} initialDate={selectedDate} />
      ))}
    </div>
  )
}
